// Triggers printing of a single tagged region (see index.css @media print rules).
// name must match one of: bill | report | voucher | list | stock | daybook
export function printSection(name) {
  const cleanup = () => {
    document.body.removeAttribute("data-print");
    window.removeEventListener("afterprint", cleanup);
  };
  document.body.setAttribute("data-print", name);
  window.addEventListener("afterprint", cleanup);
  // small delay so the DOM reflects the attribute before the print dialog opens
  setTimeout(() => {
    window.print();
    // fallback in case afterprint doesn't fire (some browsers)
    setTimeout(cleanup, 1500);
  }, 60);
}
